"use strict";

exports.__esModule = true;
exports.createSlotVeloAPIFactory = createSlotVeloAPIFactory;
var _createSdkProxy = require("./createSdkProxy");
function createSlotVeloAPIFactory(controllerConfig) {
  return {
    getSlotAPI(slotId) {
      return (0, _createSdkProxy.createSdkProxy)(controllerConfig.getSlot(slotId));
    },
    createRepeatedSlotAPI(slotId, repeatedItemId) {
      return (0, _createSdkProxy.createSdkProxy)(controllerConfig.createRepeatedSlot(slotId, repeatedItemId));
    }
  };
}
//# sourceMappingURL=slotsPlaceholderVeloAPIFactory.js.map